import { actions, selectors } from '../../state';
import { INVITE_STATUSES } from '../../constants';

export class InviteService {
  constructor($q, updStore) {
    'ngInject';
    Object.assign(this, { $q, updStore });
  }

  getInviteAndSiteConfig(token) {
    const { dispatch, getState } = this.updStore;

    const success = () => {
      const invite = selectors.invite.byToken(token);
      const state = getState();

      if (!invite.isAnswered(state)) {
        dispatch(
          actions.invite.singleton(invite.id(state)).update({
            token,
            status: INVITE_STATUSES.ANSWERED,
          })
        );
      }

      return dispatch(
        actions.signUp.setInviteInfo(getInviteFromState(invite, state))
      );
    };

    // Always sign out a user that is coming to the site with an invite token
    dispatch(actions.session.clear());

    return this.$q
      .all([
        dispatch(actions.invite.readFromToken(token)),
        dispatch(actions.siteConfig.readWithParams({ invite_token: token })),
      ])
      .then(success);
  }
}

function getInviteFromState(invite, state) {
  return {
    token: invite.token(state),
    first_name: invite.firstName(state),
    last_name: invite.lastName(state),
    middle_name: invite.middleName(state),
    suffix_name: invite.suffixName(state),
    phone: invite.cellPhone(state) || invite.homePhone(state),
    email: invite.email(state),
    move_date: invite.moveDate(state),
    from_address: invite.fromAddress(state),
    to_address: invite.toAddress(state),
  };
}
